<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" />
  </router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-style: normal;
}

body {
  font-family: PingFang-SC-Regular, ”Microsoft YaHei”, Arial, Helvetica,
    sans-serif, ”宋体”;
}

@font-face {
  font-family: "number_iconfont";
  src: url("https://images.carwins.com/erp-saas-manage-static/app-static/app-icon/fontFamily/ranking.ttf")
    format("truetype");
}

@font-face {
  font-family: "iconfont";
  src: url("../public/font/iconfont.woff2") format("woff2"),
    url("../public/font/iconfont.woff") format("woff"),
    url("../public/font/iconfont.ttf") format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 14px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ml_flex {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 5px 0;
}

.ml_flex_item {
  flex: 1;
}

.ml_flex_center {
  align-items: center;
  justify-content: center;
}
</style>
